import { isPlatformBrowser } from '@angular/common';
import { Injectable, NgZone, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute } from '@freelancer/activated-route';
import { TrackingConsentStatus } from './interface';
import { TrackingConsent } from './tracking-consent.service';

@Injectable({
  providedIn: 'root',
})
export class MgidTracking {
  private ngZone = inject(NgZone);
  private route = inject(ActivatedRoute);
  private trackingConsent = inject(TrackingConsent);
  private platformId = inject(PLATFORM_ID);

  private isEnabled = false;
  private isInitialized = false;

  async init(): Promise<void> {
    const trackingConsentStatus =
      await this.trackingConsent.getThirdPartyStatus();
    this.isEnabled =
      isPlatformBrowser(this.platformId) &&
      trackingConsentStatus === TrackingConsentStatus.AUTHORIZED;
    this.isInitialized = true;
  }

  async trackCustomEvent(buttonId: string): Promise<void> {
    if (!this.isInitialized) {
      await this.init();
    }
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      window._mgq?.push(['MgSensorInvoke', buttonId]);
    });
  }

  async loadTrackingSnippet(): Promise<void> {
    if (!this.isInitialized) {
      await this.init();
    }
    if (
      window._mgq ||
      !this.isEnabled ||
      this.route.snapshot.queryParams.utm_source !== 'mgid'
    ) {
      return;
    }

    window.MgSensorData = window.MgSensorData || [];
    window._mgq = window._mgq || [];

    window.MgSensorData.push({
      cid: 644_483,
      lng: 'us',
      project: 'a.mgid.com',
    });
    const siblingScriptTag = document.getElementsByTagName('script')[0];
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    const dateTime = Date.now();
    scriptTag.src = `https://a.mgid.com/mgsensor.js?d=${dateTime}`;
    (siblingScriptTag.parentNode as Node).insertBefore(
      scriptTag,
      siblingScriptTag,
    );
  }
}
